export interface CurrencyItem{
    locale: string,
    currency: string,
}

export interface CurrencyList{
    [key: string]: CurrencyItem
}

export const AVAILABLE_CURRENCIES: CurrencyList =  {
    CZK: {
        locale: 'cs-CZ',
        currency: 'CZK',
    },
    EUR: {
        locale: 'sk-SK',
        currency: 'EUR',
    },
    PLN: {
        locale: 'pl-PL',
        currency: 'PLN',
    },
    HUF: {
        locale: 'hu-HU',
        currency: 'HUF',
    },
    HRK:{
        locale: 'hr-HR',
        currency: 'HRK',
    },
    UAH:{
        locale: 'uk-UA',
        currency: 'UAH',
    },
    GBP:{
        locale: 'en-GB',
        currency: 'GBP',
    },
    DKK:{
        locale: 'da-DK',
        currency: 'DKK',
    },
    CHF:{
        locale: 'de-CH',
        currency: 'CHF',
    },
    NOK:{
        locale: 'no-NO',
        currency: 'NOK',
    },
    SEK:{
        locale: 'sv-SE',
        currency: 'SEK',
    },
}
